import { RxDashboard } from "react-icons/rx";
import { User } from "react-feather";
import { FiTrendingUp } from "react-icons/fi";
import { MdOutlinePercent } from "react-icons/md";
import { RxQuestionMarkCircled } from "react-icons/rx";

export default [
  {
    id: "Dashboard",
    title: "Dashboard",
    icon: <RxDashboard size={20} />,
    navLink: "/dashboard",
  },
  {
    id: "ReportsAnalytics",
    title: "Reports and Analytics",
    icon: <FiTrendingUp size={20} />,
    navLink: "/reports",
  },
  {
    id: "PromotionalMaterials",
    title: "Promotional Materials",
    icon: <MdOutlinePercent size={20} />,
    navLink: "/promotionalmaterials",
  },
  {
    id: "Profile",
    title: "Profile",
    icon: <User size={20} />,
    navLink: "/profile",
  },
  {
    id: "ServicesAndSupport",
    title: "Services And Support",
    icon: <RxQuestionMarkCircled size={30} />,
    navLink: "/servicesandsupport",
  },
  {
    id: "ComsissionAndSPayout",
    title: "Commission and Payout",
    icon: <RxQuestionMarkCircled size={30} />,
    navLink: "/commissionandpayout",
  },
];
